import { useState } from 'react';

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '¿Necesito experiencia previa para tomar este curso?',
      answer:
        'No, absolutamente no. Nuestro programa está diseñado desde cero. Te guiamos paso a paso desde lo más básico hasta estrategias avanzadas. Incluso si nunca has vendido nada online, podrás seguir el contenido sin problemas.'
    },
    {
      question: '¿Cuánto tiempo tengo acceso al contenido?',
      answer:
        'Tienes acceso de por vida. Una vez que te inscribes, el contenido es tuyo para siempre. Además, recibirás todas las actualizaciones futuras sin costo adicional.'
    },
    {
      question: '¿Qué incluye exactamente el programa?',
      answer:
        'Incluye más de 100 videos de capacitación, acceso a nuestra comunidad privada en Skool, clases en vivo mensuales, soporte 24/7, plantillas y recursos descargables, y actualizaciones constantes del contenido.'
    },
    {
      question: '¿Cuánto dinero necesito para empezar con publicidad?',
      answer:
        'Puedes empezar con tan solo $5-10 USD diarios en publicidad. Te enseñamos a optimizar cada centavo para obtener el máximo retorno de inversión. No necesitas grandes presupuestos para comenzar.'
    },
    {
      question: '¿En cuánto tiempo veré resultados?',
      answer:
        'Depende de tu dedicación y aplicación. Muchos de nuestros estudiantes ven sus primeras ventas en la primera o segunda semana. Con constancia y siguiendo nuestra metodología, los resultados llegan rápidamente.'
    },
    {
      question: '¿Hay garantía de devolución?',
      answer:
        'Sí, ofrecemos garantía de satisfacción. Si aplicas lo enseñado y no ves resultados, te devolvemos tu dinero. Queremos que te sientas seguro con tu inversión.'
    },
    {
      question: '¿Puedo acceder desde cualquier dispositivo?',
      answer:
        'Sí, puedes acceder desde tu computadora, tablet o celular. Nuestra plataforma es 100% online y está optimizada para todos los dispositivos.'
    },
    {
      question: '¿Qué tipo de productos digitales puedo vender?',
      answer:
        'Puedes vender cursos, ebooks, plantillas, software, membresías, coaching, consultorías y mucho más. Te enseñamos a identificar productos de alta demanda y cómo promocionarlos efectivamente.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <div className="flex items-center justify-center gap-2 text-emerald-600 font-semibold text-sm uppercase tracking-wider">
            <i className="ri-question-answer-line text-xl"></i>
            Preguntas Frecuentes
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">¿Tienes dudas?</h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Aquí respondemos las preguntas más comunes sobre nuestra academia
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-100 rounded-2xl overflow-hidden hover:border-emerald-200 transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="text-lg font-semibold text-gray-900 pr-4">{faq.question}</span>
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center flex-shrink-0 transition-transform duration-300">
                  <i
                    className={`ri-arrow-down-s-line text-white text-2xl transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
